import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const auditUploadReducer = createReducer(initialState, {
  UPLOAD_AUD_SHEET_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  UPLOAD_AUD_SHEET_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  UPLOAD_AUD_SHEET_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default auditUploadReducer;
